// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__puOCw","wrapper":"menu_wrapper__udYQW","item":"menu_item__UlxQr","dot":"menu_dot__vT6ah"};